import { render, staticRenderFns } from "./CancelPlanResourcesModal.vue?vue&type=template&id=0c4a812c&scoped=true"
import script from "./CancelPlanResourcesModal.vue?vue&type=script&lang=js"
export * from "./CancelPlanResourcesModal.vue?vue&type=script&lang=js"
import style0 from "./CancelPlanResourcesModal.vue?vue&type=style&index=0&id=0c4a812c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a812c",
  null
  
)

export default component.exports